<template>
    <div class="badge">
        {{ content }}
    </div>
</template>

<script>
    export default {
        props: {
            content: { type: [Number, String], required: true },
        },
    }
</script>
